// ModalSelectClient.jsx
import Modal from "../common/Modal";
import CustomSelect from "../common/CustomSelect";

function ModalSelectClient({
  clients = [], // ✅ default value
  selectedClient,
  setSelectedClient,
  onSelect,
  onClose,
}) {
  const options = clients.map((client) => {
    if (typeof client === "string") {
      return { label: client, value: client };
    }

    if (client?.label && client?.value) {
      return { label: client.label, value: client.value };
    }

    const fallbackLabel = client?.NOMBRE_CLIENTE ?? "";
    return { label: fallbackLabel, value: fallbackLabel };
  });
  const sortedOptions = [...options].sort((a, b) =>
    String(a.label ?? "").localeCompare(String(b.label ?? ""), "es", {
      sensitivity: "base",
    })
  );
  return (
    <Modal title="Cambiar cliente" onClose={onClose}>
      <span>Seleccione el cliente a administrar:</span>

      <CustomSelect
        options={sortedOptions}
        value={selectedClient}
        onChange={setSelectedClient}
        placeholder="-- Seleccionar --"
      />

      <div className="input-group_row">
        <span className="boton_opciones" onClick={onSelect}>
          Administrar
        </span>
        <span className="boton_cancelar" onClick={onClose}>
          Cancelar
        </span>
      </div>
    </Modal>
  );
}

export default ModalSelectClient;